<template lang="pug">
  .employee-accordion-wrapper
    Accordion(:startOpen="true")
      template(slot="heading")
        span.fs-19(style="text-align: center;") {{ data.employee.name}}

      template
        .display
          DBLabel(
            title="horário de entrada"
          )
            template(slot="body")
              span(
                :style="estiloPorHorarioDeEntrada(data.entryTime)"
              )
                | {{ formatHour(data.entryTime) }}
          DBLabel(
            title="local de trabalho"
            :body="data.company.name"
          )
            template(slot="body")
              span {{ data.company.name }}
              span.icon.icon-ptt-icons-pessoas(
                title="ir para folha do local de trabalho"
                @click="goToCompany(data.company.id)"
              )

</template>

<script>
import moment from 'moment'

export default {
  props: {
    data: {required: true, type: Object}
  },
  data () {
    return {
      viewMode: '2'
    }
  },
  methods: {
    goToCompany (id) {
      const company = this.$store.state.common.companies.items.find(i => i.id === id)
      if (company) {
        this.$router.goToTimesheet(moment(), null, company, true)
      }
    },
    formatHour (value) {
      if (value) {
        return moment(value).format('HH:mm')
      }
      return '-'
    },
    estiloPorHorarioDeEntrada (data) {
      const estilos = {
        esperado: 'blue',
        faltando: 'red'
      }

      const horarioAtual = moment()
      const horarioDeInicioDaJornada = moment(data).set({
        year: horarioAtual.year(),
        month: horarioAtual.month(),
        date: horarioAtual.date()
      })

      const aindaVaiComecarAJornada = horarioAtual.isBefore(horarioDeInicioDaJornada)
      return {
        color: aindaVaiComecarAJornada ? estilos.esperado : estilos.faltando
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.employee-accordion-wrapper {
  .display {
    display: grid;
    grid-template-columns: 1fr 1fr;

    .icon {
      cursor: pointer;
      margin-left: 10px;
    }
  }
}
</style>
